import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LANGS = [
  { code: "fr", full: "Français", short: "FR", flag: "🇫🇷" },
  { code: "en", full: "English", short: "EN", flag: "🇬🇧" },
  { code: "de", full: "Deutsch", short: "DE", flag: "🇩🇪" },
  { code: "it", full: "Italiano", short: "IT", flag: "🇮🇹" },
  { code: "es", full: "Español", short: "ES", flag: "🇪🇸" },
  { code: "pt", full: "Português", short: "PT", flag: "🇵🇹" },
];

function isKnownLang(seg) {
  return LANGS.some((l) => l.code === seg);
}

export default function LanguageMenu() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const parts = pathname.split("/").filter(Boolean);
  const hasPrefix = isKnownLang(parts[0]);
  const currentLang = hasPrefix ? parts[0] : "fr";
  const restParts = hasPrefix ? parts.slice(1) : parts;
  const restPath = restParts.length ? `/${restParts.join("/")}` : "/";
  const current = LANGS.find((l) => l.code === currentLang) || LANGS[0];

  const switchTo = (lng) => {
    const next = lng === "fr" ? restPath : `/${lng}${restPath === "/" ? "" : restPath}`;
    setOpen(false);
    navigate(next);
  };

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 640);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!open) return;
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  return (
    <div className="relative">
      <button
        ref={btnRef}
        type="button"
        className="border border-gray-200 bg-white px-3 py-2 rounded-lg font-bold text-sm hover:bg-gray-50 transition"
        onClick={() => setOpen((v) => !v)}
      >
        {/* Mobile: juste le drapeau */}
        <span className="sm:hidden">{current.flag} ▾</span>
        {/* Desktop: texte complet */}
        <span className="hidden sm:inline">{current.full} ▾</span>
      </button>

      {open && (
        <ul
          ref={menuRef}
          className="absolute right-0 top-full mt-2 w-44 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-50"
        >
          {LANGS.map((l) => {
            return (
              <li key={l.code}>
                <button
                  type="button"
                  className={`w-full text-left px-3 py-2 rounded-lg font-semibold text-sm transition ${
                    l.code === currentLang
                      ? "bg-emerald-50 text-emerald-700"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => switchTo(l.code)}
                >
                  {/* Mobile: juste le drapeau */}
                  <span className="sm:hidden">{l.flag}</span>
                  {/* Desktop: texte complet */}
                  <span className="hidden sm:inline">{l.full}</span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
